import { createI18n } from 'vue-i18n';
import { getLocale } from '@/utils/locale';
import { slavicPluralization } from '@/utils/slavicPluralization';

const messages = {
  ru: {
    orgDoesNotExist: 'Организация не существует',
  },
  en: {
    orgDoesNotExist: 'Organization does not exist',
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  pluralRules: {
    ru: slavicPluralization,
  },
  messages,
});
